import FieldsInterface from "@app/Interface/FieldsInterface";
import RegisterUserInterface from "@app/Interface/RegisterUserInterface";
import UserFpuAccessInterface from "@app/Interface/UserFpuAccessInterface";
import UserInterface from "@app/Interface/UserInterface";
import UserRoleTypesInterface from "@app/Interface/UserRoleTypesInterface";
import UserFpuAccessModel from "@app/Model/UserFpuAccessModel";
import RegisterUserModel from "@app/Model/UserRegisterModel";

export default class MyFpuListFunctions {

    /**
     * Updates checked status for each role type based on selected user's role permissions
     * 
     * @param user 
     * @param producerId 
     * @param roleTypes 
     * @param isCurrentUserMember
     * @returns 
     */
    static setRoleTypesCheckedStatus = (user: UserInterface, producerId: number, roleTypes: UserRoleTypesInterface[], isCurrentUserMember: boolean): UserRoleTypesInterface[] => {

        roleTypes.forEach(roleType => {

            // check if user has that permission
            const checked = MyFpuListFunctions.userHasRole(producerId, roleType.id, user);
            
            roleType.checked = checked;

            let enabled = false;

            // role must allow being granted access the master account holder
            // non-member users CAN change non-member roles
            // member users CAN change member roles
            if (roleType.masterAccountCanGrant === false) {
                enabled = false;
            } else if (!isCurrentUserMember && roleType.isNonMemberRole ) {
                enabled = true;
            } else if (isCurrentUserMember && !roleType.isNonMemberRole) {
                enabled = true;
            }

            roleType.enabled = enabled;

        });

        return roleTypes;
    }

    /**
     * Determines if use has access to the role based on role id
     * 
     * @param producerId 
     * @param roleId 
     * @param user 
     * @returns 
     */
    static userHasRole = (producerId: number, roleId: number, user: UserInterface): boolean => {

        let hasRole = false;

        if (typeof user.fpuRoles !== "boolean") {

            hasRole = user.fpuRoles.some(role => Number(role.fpu) === producerId && role.fpu_roles.includes(roleId));
            
        }
        
        return hasRole;

    }

    /**
     * Gets the data to use with API request
     * 
     * @param producerId 
     * @param user 
     * @param roleTypes 
     * @returns 
     */
    static getUserAccessData = (producerId: number, user: UserInterface, roleTypes: UserRoleTypesInterface[]): UserFpuAccessInterface => {

        const roles = roleTypes.filter(roleType => roleType.checked);

        const userFpuRoleIds: string[] = [];

        if (roles) {

            roles.forEach(role => {
                userFpuRoleIds.push(String(role.id));
            });
    
        }
        
        const acccessData: UserFpuAccessInterface = new UserFpuAccessModel();

        acccessData.fpuId = producerId;

        acccessData.userId = user.id;

        acccessData.fpuRoles = userFpuRoleIds;        

        acccessData.userEmail = user.email;

        return acccessData;

    }

    static getAddUserields = (): FieldsInterface => {

        const fields: FieldsInterface = {
            emailAddress: {
                fieldId: "emailAddress",
                formFieldId: "emailAddress",
                value: "",
                label: "Email",
                validated: "default",
                required: true,
                helperTextInvalid: "Please enter an email."
            },
            permissionCheckboxGroup: {
                fieldId: "permissionCheckboxGroup",
                formFieldId: "permissionCheckboxGroup",
                value: "",
                label: "User Role",
                validated: "default",
                required: true,
                helperTextInvalid: "Please check at least one role."
            }
        };

        return fields;

    }

    /**
     * Gets the data to use with API request
     * 
     * @param producerId 
     * @param email 
     * @param roleTypes 
     * @returns 
     */
     static getUserRegisterData = (producerId: number, email: string, roleTypes: UserRoleTypesInterface[]): RegisterUserInterface => {

        const roles = roleTypes.filter(roleType => roleType.checked);

        const userFpuRoleIds: string[] = [];

        if (roles) {

            roles.forEach(role => {
                userFpuRoleIds.push(String(role.id));
            });
    
        }
        
        const acccessData: RegisterUserInterface = new RegisterUserModel();

        acccessData.emailAddress = email;

        acccessData.fpuID = producerId;

        acccessData.fpuRoles = userFpuRoleIds;        

        return acccessData;

    }

} 